import { AllowedCallTypes, MakeActionCreator } from "../../common/const";
import { makeApiStateReducer } from "../../common/reducers/apiState";

const makeFetchStateReducer = ({
  name,
  path = "seneca/",
  idFieldName
}: MakeActionCreator) => {
  return makeApiStateReducer({
    name,
    path,
    idFieldName,
    callType: AllowedCallTypes.FETCH
  });
};

export default makeFetchStateReducer;
